import React, { useEffect, useState } from 'react';
import LayoutBlank from './layout-blank';
import './scss/login.scss';
import MetaMaskService from '../services/wallet/meta-mask-service';
import Api from '../services/api';
import AuthCookies from './auth-cookies';
import FullScreenLoader from './full-screen';

function Login(): React.ReactElement {
  const { setAuthCookie, setAddress, getAuthCookie } = AuthCookies();
  const metamaskService = new MetaMaskService();
  const [pin, setPin] = useState('');
  const [status, setStatus] = useState('Checking connected accounts..');
  const [errorMessage, setErrorMessage] = useState('');
  const [errorClass, setSetErrorClass] = useState('hide');
  const [account, setAccount] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  function setError(error:any) {
    setErrorMessage(error.message);
    setSetErrorClass('error mb-4');
  }

  function clearError() {
    setErrorMessage('');
    setSetErrorClass('hide');
  }

  function validateForm(): boolean {
    if (!pin) {
      setError(new Error('Please enter pin value'));
      return false;
    }

    clearError();

    return true;
  }
  function login(address: string) {
    if (!validateForm()) {
      return;
    }
    setIsLoading(true);
    Api.getServerChallenge(address).then((serverChallenge) => {
      metamaskService.personalSign(serverChallenge.message).then((signature) => {
        if (signature) {
          Api.getToken(serverChallenge.message, signature, '2', address)
            .then((res) => {
              const parsedRes = res.replace(/(\r\n|\n|\r|\\n)/gm, '');
              const cookieVal = parsedRes.split('OK');
              console.log(cookieVal[1]);
              setAuthCookie(cookieVal[1]);
              setAddress(address);
              setIsLoading(false);
              window.location.href = window.location.pathname + window.location.search;
            }).catch((error) => {
              setError(error);
              setIsLoading(false);
            });
        }
      }).catch((error) => {
        setError(error);
        setIsLoading(false);
      });
    }).catch((error) => {
      setError(error);
      setIsLoading(false);
    });
  }

  const handleNewAccounts = (newAccounts: string) => {
    clearError();
    setAccount(newAccounts);
    setStatus(newAccounts || 'Not connected!');
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    if (account && account.length > 0) {
      login(account);
    } else {
      metamaskService.connect().catch((error) => {
        setError(error);
      });
    }
  };

  useEffect(() => {
    if (getAuthCookie()?.length > 0 && getAuthCookie() !== 'undefined') {
      window.location.href = '/';
    }

    if (!metamaskService.isWalletInstalled()) {
      setStatus('Metamask not installed.');
    } else {
      metamaskService.init(
        undefined,
        undefined,
        handleNewAccounts,
      ).catch((error) => {
        setError(error);
      });
    }
  }, []);

  return (
    <LayoutBlank className="login-page">
      <div className="row bg-light ps-3 pe-3">
        <div className="col-md-6 d-none d-md-block login-bg" />
        <div className="col-md-6  m-auto text-center">
          <div className="text-center loading-wrapper" style={{ width: '100%' }}>
            {isLoading ? <FullScreenLoader /> : <div />}
            <h2 className="title">ALEXANDRIA LOGIN</h2>
            <form onSubmit={handleSubmit}>

              { account && account.length > 0
                ? (
                  <input
                    type="text"
                    id="pin"
                    placeholder="PIN"
                    className="form-control"
                    value={pin}
                    onChange={(e) => setPin(e.target.value)}
                  />
                )
                : <div /> }
              <button type="submit" className="btn btn-dark">{account && account.length > 0 ? 'SIGN IN' : 'CONNECT'}</button>
            </form>
            <div className="text-md-light status mb-3">{status}</div>
            <div style={{ height: '50px' }}>
              <div className={errorClass} style={{ width: '75%', margin: 'auto' }}>{errorMessage}</div>
            </div>
          </div>
        </div>
      </div>
      <div />
    </LayoutBlank>
  );
}

export default Login;
